module.exports = __webpack_public_path__ + "img/eye.4918ea11.svg";